import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['customer-code'] as const

export type panaCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const panaDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const pana: CarrierDef<panaCredType> = {
  name: 'Panama Transfer',
  scac: 'pana',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['customer-code', 'ref1']],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: panaDocumentTypes,
  credentialConfig: {
    'customer-code': { customerIdentifier: true },
  },
}
